// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".adminauth-greeting {\n\tpadding:20px;\n\ttext-align: center;\n}", ""]);
// Exports
module.exports = exports;
